import {
  ChangeDetectionStrategy,
  Component,
  Input,
  NgZone,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatStepper } from "@angular/material/stepper";
import { ActivatedRoute, Router } from "@angular/router";
import { SubscriptionStepperState } from "../subscriptions/subscription-stepper-state.service";
import { Settings } from "../../core/config/settings.service";
import { Toast } from "../../core/ui/toast.service";
import { Subscriptions } from "../../shared/billing/subscriptions.service";
import { BehaviorSubject } from "rxjs";
import { LocalStorage } from "@common/core/services/local-storage.service";
import { Plan } from "@common/core/types/models/Plan";
import { finalize } from "rxjs/operators";
import { CurrentUser } from "@common/auth/current-user";
import { PaypalSubscriptions } from "@common/billing/subscriptions/paypal-subscriptions";
import { ThemePalette } from "@angular/material/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { AppHttpClient } from "@common/core/http/app-http-client.service";
import {loadStripe} from '@stripe/stripe-js';
import { WindowRef } from "@common/core/window-ref.service";
import { environment } from "src/environments/environment";

export interface CreditCard {
  number?: number | string;
  expiration_month?: number | string;
  expiration_year?: number | string;
  security_code?: number | string;
}

export interface PeriodicElement {
  free: string;
  links: string;
  basic: string;
  growth: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {
    links: "Branded domains",
    free: "up to 1",
    basic: "up to 5",
    growth: "up to 10",
  },
  {
    links: "Branded links",
    free: "up to 1000 monthly",
    basic: "Unlimited",
    growth: "Unlimited",
  },
  {
    links: "Branded link redirects",
    free: "Unlimited",
    basic: "Unlimited",
    growth: "Unlimited",
  },
  { links: "Jiosh links", free: "-", basic: "Unlimited", growth: "Unlimited" },
  {
    links: "Jiosh link redirects",
    free: "Unlimited",
    basic: "Unlimited",
    growth: "Unlimited",
  },
  {
    links: "Link management changes",
    free: "Unlimited",
    basic: "Unlimited",
    growth: "Unlimited",
  },
  { links: "Short Links", free: "50/mo", basic: "200/mo", growth: "1,500/mo" },
  { links: "Short Links", free: "50/mo", basic: "200/mo", growth: "1,500/mo" },
  { links: "Short Links", free: "50/mo", basic: "200/mo", growth: "1,500/mo" },
  { links: "Short Links", free: "50/mo", basic: "200/mo", growth: "1,500/mo" },
  { links: "Short Links", free: "50/mo", basic: "200/mo", growth: "1,500/mo" },
];

enum Steps {
  Plans = 0,
  Period = 1,
  Address = 2,
  Payment = 3,
}

interface LocalStorageState {
  initial?: number;
  final?: number;
}

export const ONBOARDING_LOCAL_STORAGE_KEY = "be.onboarding.selected";

@Component({
  selector: "upgrade-page",
  templateUrl: "./upgrade-page.component.html",
  styleUrls: ["./upgrade-page.component.scss"],
  providers: [SubscriptionStepperState],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgradePageComponent implements OnInit {
  @ViewChild(MatStepper, { static: true }) stepper: MatStepper;
  @Input() set mode(value: "pricing" | "subscribe" | "changePlan") {
    this.state.mode = value;
  }
  // @Output() outputFromChild : EventEmitter<string> = new EventEmitter();;

  public loading$ = new BehaviorSubject<boolean>(false);
  displayedColumns: string[] = ["links", "free", "basic", "growth"];
  dataSource = ELEMENT_DATA;
  isFreeze;
  url: SafeResourceUrl;

  color: ThemePalette = "accent";
  checked = false;
  disabled = false;

  labelName: string;
  data1:any;

  defaultYear:any
  defaultCurrency:any
  
  stripe: any;
  elements: any;

  constructor(
    private subscriptions: Subscriptions,
    private route: ActivatedRoute,
    public settings: Settings,
    private router: Router,
    private toast: Toast,
    public state: SubscriptionStepperState,
    private localStorage: LocalStorage,
    private currentUser: CurrentUser,
    private paypalSubscriptions: PaypalSubscriptions,
    private http: AppHttpClient,
    private domSanitizer: DomSanitizer,
    private winRef: WindowRef,
    private ngZone: NgZone,
  ) {}

  convertIfram(urls) {
    this.url = this.domSanitizer.bypassSecurityTrustResourceUrl(urls);
  }

  async ngOnInit() {
    this.route.data.subscribe((data: { plans: Plan[] }) => {
      this.state.setPlans(data.plans);
      console.log("data1", data.plans);
      console.log("state-plan-1", this.state.plans);
      if (this.state.mode === "subscribe") {
        this.hydrateStateFromLocalStorage();
      }
    });

    this.stripe = await loadStripe(environment.stripeKey);

    // let baseUrl = "https://aws.jio.sh/api/v1/chargebee/create-charge"
    // const body = {
    //   item_price_id: 'cbdemo_lite-INR-yearly',
    //   email: 'test@gmail.com'
    // }
    // this.http.post(baseUrl, body)
    //   .subscribe(
    //     (apiRes: any) => {
    //       console.log(apiRes);
    //       console.log('chargBee', apiRes)
    //       this.convertIfram(apiRes.url)
    //     },
    //     (apiErr: any) => {
    //       console.log(apiErr);
    //     }
    //   )

    // if (this.route.snapshot?.queryParams?.item_price_id) {
    //   console.log("router", this.route.snapshot?.queryParams?.item_price_id);

    //   let baseUrl = "https://aws.jio.sh/api/v1/chargebee/create-charge";
    //   const body = {
    //     item_price_id: this.route.snapshot?.queryParams?.item_price_id,
    //     email: this.route.snapshot?.queryParams?.email,
    //   };
    //   this.http.post(baseUrl, body).subscribe(
    //     (apiRes: any) => {
    //       console.log(apiRes);
    //       console.log("chargBee", apiRes);
    //       this.convertIfram(apiRes.url);
    //     },
    //     (apiErr: any) => {
    //       console.log(apiErr);
    //     }
    //   );
    // }
  }

  selectedTabValue(event:any, mode: any) {
    console.log('event', event)
    console.log("mode", mode);
    if (mode === "year") {
      this.defaultYear = event.tab.textLabel;
    } else {
      this.defaultCurrency = event.tab.textLabel;
      console.log("event", event);
    }
    // this.selectedTabValue
    console.log('event.textLabel', event.tab.textLabel)
  }

  private hydrateStateFromLocalStorage() {
    const storedState = this.localStorage.get(
      ONBOARDING_LOCAL_STORAGE_KEY
    ) as LocalStorageState;
    if (storedState && storedState.initial && storedState.final) {
      const initialPlan = this.state.plans.find(
          (p) => p.id === storedState.initial
        ),
        finalPlan = this.state.plans.find((p) => p.id === storedState.final);
      if (initialPlan && finalPlan) {
        this.state.selectInitialPlan(initialPlan);
        this.state.selectPlanById(finalPlan.id);
        this.stepper.selectedIndex = Steps.Payment;
      }
    }
  }

  public goToPeriodStep() {
    this.stepper.selectedIndex = Steps.Period;
  }

  // private generateChargebeeHostedPage(plan) {

  //   (<any>window).Chargebee.init({
  //     site: "jio.sh", // your test site
  //     domain: "https://jiosh.chargebee.com" // this is an optional parameter.
  //     // Use this, if custom domain is enabled for your site
  //   })

  //   let chargebeeInstance = (<any>window).Chargebee.getInstance();
  //   let http = this.http;
  //   let router = this.router;

  //   chargebeeInstance.openCheckout({          
  //     // This function returns a promise that resolves a hosted page object.
  //     // If the library that you use for making ajax calls, can return a promise, you can directly return that

  //     hostedPage: function() {
  //       // We will discuss on how to implement this end point in the next step.
        
  //       let body = {
  //         chargebee_item_price_id: plan.chargebee_item_price_id,
  //       };

  //       return http.post('chargebee/create-charge', body)
  //                   .toPromise()
  //                   .then(
  //                     response => response, // return json response
  //                     error => {
  //                       console.log(error);
  //                     }
  //                   )
  //     },

  //     success: function(hostedPageId) {
  //       // success callback
  //       console.log(hostedPageId);
  //       console.log('success');
  //       chargebeeInstance.closeAll();
  //       router.navigate(['chargebee', hostedPageId, 'payment-success']);
  //     },

  //     error: function(error) {
  //       console.log(error);
  //     }
  //   });
  // }

  // public buy(plan) {

  //   this.loading$.next(true);
  //   let chargebeeScript = document.createElement("script");
  //   chargebeeScript.id = "chargebee-script";
  //   chargebeeScript.type = "text/javascript";
  //   chargebeeScript.async = true;
  //   chargebeeScript.src = "https://js.chargebee.com/v2/chargebee.js";
  //   chargebeeScript.onload = () => {

  //     this.loading$.next(false);
  //     this.generateChargebeeHostedPage(plan);
  //   };
  //   document.body.appendChild(chargebeeScript);
  // }

  public buy() {

    // razorpay for only INR currency
    if (this.state.selectedPlan$.value.currency === 'INR') {

      this.loading$.next(true);

      if (this.currentUser.isSubscribed()) {
        
        this.updateRazorpayPayment()
      }
      else {

        this.createRazorpayPayment()
      }
    }
    else { // stripe for rest
      
      this.beginStripePayment()
    }
  }

  public verifyRazorpaySignature(response) {

    this.loading$.next(true);

    this.http.get('verify-razorpay-signature', {
      razorpay_payment_id: response.razorpay_payment_id,
      razorpay_signature: response.razorpay_signature
    })
    .subscribe(
      (response: any) => {
        console.log(response);

        this.loading$.next(false);
        // console.log(`/razorpay-payment-created?subscription_id=${response.subscription_id}&plan_id=${response.plan_id}`);
        
        // this.winRef.nativeWindow.location = `/razorpay-payment-created?subscription_id=${response.subscription_id}&plan_id=${response.plan_id}`
        this.router.navigate(['/razorpay-payment-created'], {
          queryParams: {
            'subscription_id': response.subscription_id,
            'plan_id': response.plan_id
          }
        })
      },
      (error: any) => {
        console.log(error);
        this.loading$.next(false);
      }
    )
  }

  public createRazorpayPayment() {

    this.http.get('create-razorpay-subscription', { 
      planId: this.state.selectedPlan$.value.uuid
    })
    .subscribe(
      (response: any) => {
        console.log(response);
        let script = document.createElement('script')
        script.async = true
        script.src = 'https://checkout.razorpay.com/v1/checkout.js'
        document.head.appendChild(script)

        const options:any = {
            "key": response.key,
            "subscription_id": response.subscription_id, 
            "name": "JIOSH",
            "description": "Subscription",
            "prefill": { 
              "name":  `${response.user.first_name || ''} ${response.user.last_name || ''}`,
              "email": response.user.email
            }
        };

        options.handler = ((response, error) => {

          console.log(response);
          // alert(response.razorpay_payment_id);
          // alert(response.razorpay_order_id);
          // alert(response.razorpay_signature);
          options.response = response;

          // using ngZone because this razorpay code is like an external js file
          // so in verifyRazorpaySignature() this.router.navigate won't redirect to component we mentioned
          this.ngZone.run(() => {
            this.verifyRazorpaySignature(response)
          })
        })

        script.onload = () => {

            var rzp1 = new this.winRef.nativeWindow.Razorpay(options);
            rzp1.on('payment.failed', function (response){
              console.log(response)
            });
            rzp1.open();
            this.loading$.next(false);
        }
      },
      (error: any) => {
        console.log(error);
        this.loading$.next(false);
      }
    )
  }

  public updateRazorpayPayment() {

    this.http.get('update-razorpay-subscription', { 
      planId: this.state.selectedPlan$.value.uuid
    })
    .subscribe(
      (response: any) => {
        console.log(response);
        
        this.loading$.next(false);
        this.router.navigate(['/razorpay-payment-updated'], {
          queryParams: {
            'subscription_id': response.subscription_id
          }
        })
      },
      (error: any) => {
        console.log(error);
        this.loading$.next(false);
      }
    )
  }

  public beginStripePayment() {

    this.elements = this.stripe.elements();
    let user = this.currentUser.model$.value;
    
    const addressElement = this.elements.create('address', {
      mode: 'billing',
      defaultValues: {
        name: `${user.first_name || ''}${user.last_name ? ` ${user.last_name}` : ''}`
      }
    });

    this.stepper.next();

    addressElement.mount("#address-element");
  }

  public async handleAddressSubmit() {

    const addressElement = this.elements.getElement('address');
    console.log(addressElement);
    
    const { complete, value } = await addressElement.getValue();
    console.log(value);
    
    if (complete) {

      console.log('complete address');
      // Allow user to proceed to the next step
      // Optionally, use value to store the address details
      this.createStripeIntent(value);
    }
  }

  public async createStripeIntent(addressDetails) {
    
    this.loading$.next(true);

    this.http.get('create-stripe-intent', { 
      planId: this.state.selectedPlan$.value.uuid,
      name: addressDetails.name,
      city: addressDetails.address.city,
      country: addressDetails.address.country,
      line1: addressDetails.address.line1,
      line2: addressDetails.address.line2,
      postalCode: addressDetails.address.postal_code,
      state: addressDetails.address.state
    })
    .subscribe(
      (response: any) => {
        console.log(response);

        // while downgrade we dont receive client secret
        if (response.clientSecret) {

          this.elements = this.stripe.elements({
            clientSecret: response.clientSecret
          })

          const paymentElement = this.elements.create("payment", {
            layout: {
              type: 'accordion',
              defaultCollapsed: false,
              radios: false,
              spacedAccordionItems: true
            }
          });

          this.stepper.next();

          this.loading$.next(false);

          paymentElement.mount("#payment-element");
        }
        else {

          this.toast.open('Plan changed successfully, redirecting to subscription page', {
            duration: 15000
          });

          setTimeout(() => {

            this.loading$.next(false);
            this.router.navigate(['/billing/subscription'])
            // this.winRef.nativeWindow.location = '/billing/subscription'   
          }, 5000);
        }

      },
      (error: any) => {
        console.log(error);
        this.loading$.next(false);
      }
    )
  }

  public async handleSubmit() {
    
    const { error } = await this.stripe.confirmPayment({
      elements: this.elements,
      confirmParams: {
        return_url: `${window.location.origin}/stripe-return-url`
      }
    });
    console.log(error);
    if (error) {
      // This point will only be reached if there is an immediate error when confirming the payment. 
      // Show error to your customer (for example, payment details incomplete)
      const messageContainer = document.querySelector('#error-message');
      messageContainer.textContent = error.message;
    }
  }

  public nextStep() {
    
    // User is changing their plan, there's no need to get their payment information
    if (
      this.state.mode === "changePlan" &&
      this.stepper.selectedIndex === Steps.Period
    ) {
      this.changePlan();
      // User has selected free plan in pricing page. Redirect them to sign-up page
    } else if (
      this.state.mode === "pricing" &&
      // this.state.selectedPlan$.value.free &&
      this.stepper.selectedIndex === Steps.Plans
    ) {
      this.router.navigate(["register"]);
      // User has selected paid plan on pricing page, but have not signed up yet,
      // store selected plan data in local storage and redirect to sign-up page
    } else if (
      this.state.mode === "pricing" &&
      this.stepper.selectedIndex === Steps.Period
    ) {
      this.localStorage.set(ONBOARDING_LOCAL_STORAGE_KEY, {
        initial: this.state.initialPlan$.value.id,
        final: this.state.selectedPlan$.value.id,
      });
      this.router.navigate(["register"]);
      // Continue to next subscription flow step
    } else {
      this.stepper.next();
    }
  }

  public onCompleted() {
    this.loading$.next(false);
    this.router.navigate(["/"]);
    this.localStorage.remove(ONBOARDING_LOCAL_STORAGE_KEY);
    this.toast.open({
      message: 'Subscribed to ":planName" plan successfully.',
      replacements: { planName: this.getSelectedOrParentPlanName() },
    });
  }

  /**
   * Change user's active subscription plan to specified one.
   */
  public changePlan() {
    const plan = this.state.selectedPlan$.value,
      activeSubscription = this.currentUser.getSubscription();
    // user already subscribed
    if (this.currentUser.getSubscription({ planId: plan.id })) {
      return;
    }
    this.loading$.next(true);
    if (activeSubscription.gateway_name === "paypal") {
      this.paypalSubscriptions
        .changePlan(activeSubscription, plan)
        .then((user) => {
          this.loading$.next(false);
          this.currentUser.assignCurrent(user);
          this.router.navigate(["/billing/subscription"]);
          this.toast.open("Subscription plan changed.");
        });
    } else {
      this.subscriptions
        .changePlan(activeSubscription.id, plan)
        .pipe(finalize(() => this.loading$.next(false)))
        .subscribe((response) => {
          console.log("response", response);
          this.currentUser.assignCurrent(response["user"]);
          this.router.navigate(["/billing/subscription"]);
          this.toast.open("Subscription plan changed.");
        });
    }
  }

  private getSelectedOrParentPlanName(): string {
    const selectedPlan = this.state.selectedPlan$.value;
    const plan = selectedPlan.parent ? selectedPlan.parent : selectedPlan;
    return plan.name;
  }
}
